import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  DialogCancelButton,
  DialogDestructiveActionButton,
  UncoloredButtonText,
} from "../../../components";

function RecipientListOverwriteDialog({
  onClose,
  onOverwriteList,
  open,
  name,
  ...rest
}) {
  const { t } = useTranslation();

  return (
    <Dialog {...rest} open={open} onClose={onClose}>
      <DialogTitle>{t("Overwriting Recipient List")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t(
            "Creating a new recipient list will delete {{name}}. Would you like to continue?",
            {
              name: name ?? t("your in progress list"),
            }
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <DialogCancelButton
          data-test-id="recipientList-overwrite-dialog-button-cancel"
          onClick={onClose}
        >
          {t("Cancel")}
        </DialogCancelButton>
        <UncoloredButtonText
          data-test-id="recipientList-overwrite-dialog-button-open-existing"
          component={Link}
          to="/recipient-lists/create"
        >
          {t("Open Existing List")}
        </UncoloredButtonText>
        <DialogDestructiveActionButton
          data-test-id="recipientList-overwrite-dialog-button-new"
          onClick={onOverwriteList}
        >
          {t("Create New List")}
        </DialogDestructiveActionButton>
      </DialogActions>
    </Dialog>
  );
}

export default memo(RecipientListOverwriteDialog);
